import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

// Componentes.
import { QSignerHomeComponent } from './qSignerhome.component';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { NavigationBarModule } from '@blocks/navigation-bar/navigation-bar.module';

// Servicios.
import { QSignerHomeService } from '@services/qsignerhome.service';
import { ApiServerService } from '@services/api-server.service';
import { QsignerService } from '@services/qsigner.service';
import { StorageServiceModule } from 'angular-webstorage-service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

// Pdf.
import { PdfViewerModule } from 'ng2-pdf-viewer';

// Syncfusion.
import { SignatureModule } from '@syncfusion/ej2-angular-inputs';

@NgModule({
  declarations: [QSignerHomeComponent],
  imports: [FormsModule, CommonModule, TranslateModule, BrowserModule, PdfViewerModule, NavigationBarModule, SignatureModule],
  exports: [QSignerHomeComponent],
  providers: [BsLocaleService, TranslateService, QSignerHomeService, ApiServerService, QsignerService, StorageServiceModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class QSignerHomeModule {}
